/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import moment from 'moment';

import { useGlobal } from '../../../../contexts/Global/context';
import { useTitular } from '../../../../contexts/InclusaoTitular/context';
import { useDependente } from '../../../../contexts/InclusaoDependente/context';

import Alert from '../../../../components/Alert';
import CardDocument from '../../../../components/Cards/Document';
import Modal from '../../../../components/Modal';
import FileViewer from '../../../../components/FileViewer';
import Button from '../../../../components/Button';
import StepProgress from '../../../../components/StepProgress';
import Accordion from '../../../../components/Accordion';

import MensagensAlertas from '../Alertas';

import dataDocs from './data';
import { base64toBlob, addTimeToNameFile, cloneObject, generatePdf, getAge } from '../../../../utils';
import steps from '../../../../utils/steps.json';

import regexps from '../../../../utils/regexps';

import {
    salvarRascunho,
    salvarArquivo,
    buscarArquivo,
    removerArquivo,
    buscaDocumentosPorContrato,
    getValoresPlanos,
} from '../../../../services';

import RAC from '../PDFs/RAC';
import CartaOrientacao from '../PDFs/CartaOrientacao';

import * as S from './styles';
import CartaDeclaracaoSaude from '../PDFs/DeclaracaoSaude';
import { PageContainer, ButtonSection, ContainerButton } from '../../../../styles/styles';

function Documentos() {
    const history = useHistory();

    const { dataTitular, setDataTitular, flow, othersDocuments, setOthersDocuments } = useTitular();
    const { dataActiveContract } = useGlobal();
    const { dataDependentes, setDataDependentes } = useDependente();

    const hasDependentes = dataDependentes.length > 0;
    const hasTitular = flow === 'adicionar_titular';

    const [showModal, setShowModal] = useState(false);
    const [modalInfo, setModalInfo] = useState({});

    const [titularDocsValidated, setTitularDocsValidated] = useState(!hasTitular);
    const [dependentesDocsValidated, setDependentesDocsValidated] = useState(!hasDependentes);

    const [titularDocsList, setTitularDocsList] = useState([]);
    const [dependentesDocsList, setDependentesDocsList] = useState(hasDependentes ? dataDependentes.map(() => []) : []);

    const [defaultDocs, setDefaultDocs] = useState([]);
    const [listRequiredIds, setListRequiredIds] = useState([]);

    const defaultValueError = { extension: '', error: false };
    const [errFile, setErroFile] = useState(defaultValueError);
    const DEFAULT_DOCS_IDS = [-1, -2, -3];

    const DOWNLOAD_LIST = {
        '-1': (title, newHolderData, newDataDependents) =>
            generatePdf(
                <RAC
                    form={{
                        flow,
                        dataTitular: newHolderData || dataTitular,
                        dataDependentes: newDataDependents || dataDependentes,
                    }}
                />,
                title
            ),
        '-2': (title, form) => generatePdf(<CartaOrientacao form={form} />, title),
        '-3': (title) => generatePdf(<CartaDeclaracaoSaude form={{ dataTitular }} />, title),
    };

    function validateDocs(dadosBeneficiario, docsList, requiredIds = listRequiredIds) {
        const newDocs = dataDocs.default.filter((doc) => requiredIds.includes(doc.id));

        setDefaultDocs(newDocs);

        const hasDefaultDocs = requiredIds.length
            ? requiredIds.every((id) => dadosBeneficiario.documents.find((doc) => doc.id === id))
            : true;

        const otherDocsIds = docsList.filter((doc) => !doc.opcional).map((doc) => doc.id);

        const hasOtherDocs = otherDocsIds.every((id) => dadosBeneficiario.documents.find((doc) => doc.id === id));

        return hasDefaultDocs && hasOtherDocs;
    }

    async function handleShowModal(file) {
        const payload = {
            cpfCnpj: file.cpf,
            numeroContrato: dataActiveContract.numero,
            tipoArquivo: file.id,
            nomeArquivo: file.name,
        };

        const responseDoc = await buscarArquivo(payload);
        const documento = responseDoc[0];

        const mode = ['jpeg', 'jpg', 'png', 'svg'].includes(documento.extArquivo.toLowerCase())
            ? 'image'
            : 'application';

        const blob = base64toBlob(documento.base64, `${mode}/${documento.extArquivo}`);
        const blobUrl = URL.createObjectURL(blob);

        setModalInfo(
            file.name
                ? {
                      title: file.name,
                      content: (
                          <FileViewer fileExtension={documento.extArquivo} src={blobUrl} base64={documento.base64} />
                      ),
                  }
                : {
                      title: 'Orientações',
                      content: (
                          <p>
                              Colaborador contratado (qualquer um dos documentos abaixo é aceito): <br />
                              - Última guia do recolhimento do Fundo de Garantia (FGTS). <br />
                              - Cópia do registro em papel timbrado e assinado pela empresa. <br />
                              - Cópia das páginas da carteira de trabalho com foto. <br />
                              <br />
                              Colaborador temporário: contrato temporário de trabalho entre empresa e pessoa
                              colaboradora. <br />
                              <br />
                              Sociedade: documento que comprova a sociedade entre pessoas sócias, administradoras e
                              empresa.
                          </p>
                      ),
                      backButton: true,
                  }
        );

        setShowModal(true);
    }

    function handleFileChange({ event, id, label, indexDependente = false, isOthers = false }) {
        if (!event.target.files) return;

        const file = event.target.files[0];
        const { name: fileName, size: fileSize } = file;

        const fileNameFiltered = fileName.replace(regexps.charRemove, '');

        const acceptedFormats = ['jpeg', 'jpg', 'png', 'pdf', 'svg'];

        const fileExtention = fileNameFiltered.substring(fileNameFiltered.lastIndexOf('.') + 1);

        if (!acceptedFormats.includes(fileExtention.toLowerCase())) {
            setErroFile({
                ...errFile,
                extension: fileExtention,
                error: true,
            });
            event.target.value = null;
            setTimeout(() => {
                window.document.getElementById('page-content').scrollTo(0, 0);
            }, 100);
            return;
        }
        setErroFile(defaultValueError);

        let cpfBeneficiario = '';
        let newDataDependentes = '';
        let documents = '';
        let newDataTitular = '';

        event.target.value = null;

        const fileSizeKb = fileSize / 1024;

        if (fileSizeKb > 25000) {
            const modalContent = 'Somente é permitido anexar documentos com tamanho inferior a 25000KB (25MB).';
            setModalInfo({
                title: 'Erro',
                content: <p>{modalContent}</p>,
                backButton: true,
            });

            setShowModal(true);
            return;
        }

        const dataDocument = {
            id,
            label,
            name: addTimeToNameFile(fileNameFiltered, fileExtention),
            size: `${fileSizeKb.toFixed(2)}Kb`,
        };

        if (indexDependente !== false) {
            newDataDependentes = cloneObject(dataDependentes);

            const foundDocument = newDataDependentes[indexDependente].documents.filter(
                (document) => document.id === id && document.name === fileNameFiltered
            );
            if (foundDocument.length) return;

            if (id === -97) {
                const documentosComplementaresDependentes = newDataDependentes[indexDependente].documents.filter(
                    (document) => document.id === id
                );
                if (documentosComplementaresDependentes.length >= 5) return;
            }

            newDataDependentes[indexDependente].documents.push(dataDocument);

            cpfBeneficiario = newDataDependentes[indexDependente].cpf.unmaskedValue;
        } else if (isOthers) {
            documents = cloneObject(othersDocuments);

            const foundDocument = documents.filter(
                (document) => document.id === id && document.name === fileNameFiltered
            );

            if (foundDocument.length || othersDocuments.length >= 5) return;

            documents.push(dataDocument);

            cpfBeneficiario = dataTitular.cpf.unmaskedValue;
        } else {
            newDataTitular = cloneObject(dataTitular);

            const foundDocument = newDataTitular.documents.filter(
                (document) => document.id === id && document.name === fileNameFiltered
            );
            if (foundDocument.length) return;

            if (id === -98) {
                const documentosComplementaresTitular = newDataTitular.documents.filter(
                    (document) => document.id === id
                );
                if (documentosComplementaresTitular.length >= 5) return;
            }

            newDataTitular.documents.push(dataDocument);

            cpfBeneficiario = newDataTitular.cpf.unmaskedValue;
        }

        const reader = new FileReader();

        reader.onloadend = async () => {
            const dataDoc = [...defaultDocs].find((document) => document.id === id);

            const payloadDocument = {
                cpfCnpj: cpfBeneficiario,
                numeroContrato: dataActiveContract.numero,
                tipoArquivo: dataDocument.id,
                nomeArquivo: dataDocument.name,
                extArquivo: fileExtention,
                descArquivo: dataDoc?.label || 'Outros',
                base64: reader.result.split(',')[1],
            };

            const response = await salvarArquivo(payloadDocument);

            if (![201, 200, 409].includes(response)) {
                // eslint-disable-next-line no-alert
                alert(`Erro ${response} ao subir arquivo: ${dataDocument.name}`);
                return;
            }

            if (indexDependente !== false) {
                setDataDependentes(newDataDependentes);

                const dependenteValidated = newDataDependentes.every((dependente, index) =>
                    validateDocs(dependente, dependentesDocsList[index])
                );
                setDependentesDocsValidated(dependenteValidated);
            } else if (isOthers) {
                cpfBeneficiario = dataTitular.cpf.unmaskedValue;

                setOthersDocuments([...documents]);
            } else {
                setDataTitular(newDataTitular);

                const titularValidated = validateDocs(newDataTitular, titularDocsList);
                setTitularDocsValidated(titularValidated);
            }
        };

        reader.readAsDataURL(file);
    }

    async function handleGeneratePDF({ id, label, data }) {
        if (label === 'RAC') {
            const { valores: prices } = await getValoresPlanos(
                dataActiveContract.numero,
                dataTitular.healthPlan.value,
                {
                    situacaoBeneficiario: 'Ativo',
                    periodoNegociacao: moment(dataActiveContract.dataUltimaVigencia, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                }
            );

            if (!prices?.length) {
                return DOWNLOAD_LIST[id](label);
            }

            const holderAge = getAge(data.birth.value);
            const dependentsAge = dataDependentes.map((dependent) => getAge(dependent.birth.value));

            const [holderPrice, dependentsPrice] = prices.map((price) => {
                if (price.tipoBeneficiario === 'Titular') {
                    const holderData = price.faixaEtarias.find((range) => {
                        const rangeSplit = range.faixa.split('-');

                        return holderAge >= rangeSplit[0] && holderAge <= rangeSplit[1];
                    });

                    return holderData.mensalidade;
                }

                if (price.tipoBeneficiario === 'Dependente') {
                    const [dependentsData] = dependentsAge.map((dependentAge) =>
                        price.faixaEtarias.filter((range) => {
                            const rangeSplit = range.faixa.split('-');

                            return dependentAge >= rangeSplit[0] && dependentAge <= rangeSplit[1];
                        })
                    );

                    return dependentsData?.map((dependentData) => dependentData.mensalidade) || [];
                }
            });

            const newDataDependents = dataDependentes.map((dependent, index) => ({
                ...dependent,
                planPrice: dependentsPrice ? dependentsPrice[index] : null,
            }));

            setDataTitular({ ...dataTitular, planPrice: holderPrice });
            setDataDependentes(newDataDependents);

            return DOWNLOAD_LIST[id](label, { ...dataTitular, planPrice: holderPrice }, newDataDependents);
        }

        return DOWNLOAD_LIST[id](label, data);
    }

    function handleFileDelete({ id, fileName, indexDependente = false, isOthers = false }) {
        let cpfBeneficiario = '';

        if (indexDependente !== false) {
            const newDataDependentes = cloneObject(dataDependentes);

            const indexFile = newDataDependentes[indexDependente].documents.findIndex(
                (document) => document.id === id && document.name === fileName
            );

            newDataDependentes[indexDependente].documents.splice(indexFile, 1);

            cpfBeneficiario = newDataDependentes[indexDependente].cpf.unmaskedValue;

            setDataDependentes(newDataDependentes);

            const dependenteValidated = newDataDependentes.every((dependente, index) =>
                validateDocs(dependente, dependentesDocsList[index])
            );
            setDependentesDocsValidated(dependenteValidated);
        } else if (isOthers) {
            let documents = cloneObject(othersDocuments);

            documents = documents.filter((document) => document.id === id && document.name !== fileName);

            cpfBeneficiario = dataTitular.cpf.unmaskedValue;

            setOthersDocuments([...documents]);
        } else {
            const newDataTitular = cloneObject(dataTitular);

            const indexFile = newDataTitular.documents.findIndex(
                (document) => document.id === id && document.name === fileName
            );

            newDataTitular.documents.splice(indexFile, 1);

            cpfBeneficiario = newDataTitular.cpf.unmaskedValue;

            setDataTitular(newDataTitular);

            const titularValidated = validateDocs(newDataTitular, titularDocsList);
            setTitularDocsValidated(titularValidated);
        }

        const payload = {
            cpfCnpj: cpfBeneficiario,
            numeroContrato: dataActiveContract.numero,
            tipoArquivo: id,
            nomeArquivo: fileName,
        };

        removerArquivo(payload);
    }

    async function handleSaveDraft() {
        const rascunhoStatus = await salvarRascunho({
            cpfCnpj: dataTitular.cpf.unmaskedValue,
            numeroContrato: dataActiveContract.numero,
            rascunho: {
                flow,
                dataHora: new Date().toISOString(),
                dataTitular,
                dataDependentes,
                othersDocuments,
            },
        });

        if (rascunhoStatus === 200) {
            history.push({
                pathname: '/movimentacao_cadastral/validar_inclusao_beneficiario',
                alertMessage: {
                    title: 'Rascunho salvo com sucesso!',
                    message: [
                        'Quando quiser, volte ao formulário para continuar preenchendo os dados, acessando a opção ',
                        <Link to="/movimentacao_cadastral/movimentacoes_pendentes">
                            <u>Movimentações pendentes.</u>
                        </Link>,
                    ],
                },
            });
        } else {
            let modalContent = 'Erro ao salvar rascunho. Tente novamente.';
            if (rascunhoStatus === 409) modalContent = 'Já existe rascunho salvo para este CPF/Contrato.';

            setModalInfo({
                title: 'Erro',
                content: <p>{modalContent}</p>,
                backButton: true,
            });

            setShowModal(true);
        }
    }

    function handleFowardStep() {
        history.push('/movimentacao_cadastral/revisar_dados');
    }

    function treatDocsResponse(docs) {
        return docs
            ? docs.map(({ documento: { codigo, nome } }) => ({
                  id: codigo,
                  label: nome,
              }))
            : [];
    }

    useEffect(() => {
        (async () => {
            if (!dataTitular.cpf) history.push('/movimentacao_cadastral/adicionar_beneficiario');

            const { isPme, isHealth, isAdesao } = dataActiveContract;
            const requiredIds = [];

            if (!isAdesao) {
                if (isPme && isHealth) {
                    requiredIds.push(-2);

                    if (dataActiveContract.obrigatorioDeclaracaoSaude) {
                        requiredIds.push(-1, -3);
                    }
                }
            }

            setListRequiredIds(requiredIds);

            const opcionalTitularDocs = [
                {
                    id: 14,
                    label: 'Vinculo empregatício',
                    opcional: true,
                },
                {
                    id: -98,
                    label: 'Documentos complementares',
                    opcional: true,
                },
            ];

            const opcionalDependentesDocs = [
                {
                    id: 16,
                    label: 'Vinculo de parentesco',
                    opcional: true,
                },
                {
                    id: -97,
                    label: 'Documentos complementares',
                    opcional: true,
                },
            ];

            const mov = dataActiveContract.parametros.tipoMovimentacaoCadastral;

            if (mov === 'T') {
                setTitularDocsValidated(true);
                if (hasTitular) setTitularDocsList(opcionalTitularDocs);

                setDependentesDocsValidated(true);
                if (hasDependentes) setDependentesDocsList(dependentesDocsList.fill(opcionalDependentesDocs));

                return;
            }

            if (hasTitular) {
                const otherTitularDocs = await buscaDocumentosPorContrato(
                    dataActiveContract.numero,
                    'InclusaoTitular',
                    moment(dataTitular.birth.value).format('yyyy-MM-DD')
                );

                const treatedResponse = treatDocsResponse(otherTitularDocs);

                const newTitularDocsList = treatedResponse.length ? [...treatedResponse] : opcionalTitularDocs;

                setTitularDocsList(newTitularDocsList);

                const titularValidated = validateDocs(dataTitular, [...newTitularDocsList], requiredIds);

                setTitularDocsValidated(titularValidated || !hasTitular);
            }

            if (hasDependentes) {
                const requestDependentes = dataDependentes.map(async (dependente) => {
                    const response = await buscaDocumentosPorContrato(
                        dataActiveContract.numero,
                        'InclusaoDependente',
                        moment(dependente.birth.value).format('yyyy-MM-DD'),
                        dependente.kinshipDegree.value
                    );

                    const treatedResponse = treatDocsResponse(response);

                    return treatedResponse;
                });

                const results = await Promise.all(requestDependentes);

                const treatedResults = results.map((result) => (!result.length ? opcionalDependentesDocs : result));

                setDependentesDocsList(treatedResults);

                const dependentesValidated = dataDependentes.every((dependente, index) =>
                    validateDocs(dependente, treatedResults[index], requiredIds)
                );

                setDependentesDocsValidated(dependentesValidated || !hasDependentes);
            }
        })();
    }, []);

    return (
        <PageContainer>
            <StepProgress
                steps={flow === 'selecionar_titular' ? steps.inclusaoDependentes : steps.inclusaoTitular}
                activeStep={3}
            />

            <MensagensAlertas />

            <S.PageTitle>
                Agora precisamos que você compartilhe com a gente alguns documentos para análise, tudo bem?
            </S.PageTitle>

            {!!errFile.error && (
                <Alert
                    type="1"
                    title="Não foi possível anexar o arquivo."
                    message={`O formato do arquivo "${errFile.extension}" não é suportado.`}
                />
            )}
            {flow === 'adicionar_titular' && [...defaultDocs, ...titularDocsList].length > 0 && (
                <Accordion title={`Titular - ${dataTitular.fullName?.value}`}>
                    {[...defaultDocs, ...titularDocsList].map((doc) => {
                        const isDefaultDoc = DEFAULT_DOCS_IDS.includes(doc.id);
                        const files = dataTitular.documents.filter((document) => document.id === doc.id);

                        if (isDefaultDoc && !listRequiredIds.includes(doc.id)) return <></>;

                        return (
                            <CardDocument
                                key={`${doc.id}-${doc.label}`}
                                id={doc.id}
                                name={doc.label}
                                label={isDefaultDoc && 'Baixar (PDF)'}
                                onLabelClick={() =>
                                    handleGeneratePDF({ id: doc.id, label: doc.label, data: dataTitular })
                                }
                                files={files}
                                onFileChange={(event) => handleFileChange({ event, id: doc.id, label: doc.label })}
                                onDeleteFile={handleFileDelete}
                                onClickViewFile={(dataFileClicked) =>
                                    handleShowModal({
                                        hasFiles: !!files,
                                        cpf: dataTitular.cpf.unmaskedValue,
                                        ...dataFileClicked,
                                    })
                                }
                            />
                        );
                    })}
                </Accordion>
            )}
            {dataDependentes.length > 0 &&
                dataDependentes.map(
                    (dependente, index) =>
                        [...defaultDocs, ...dependentesDocsList[index]].length > 0 && (
                            <Accordion
                                key={() => `${dependente.fullName.value}-${index}`}
                                title={`Dependente ${(index + 1).toString().padStart(2, '0')} - ${
                                    dependente.fullName.value
                                }`}
                            >
                                {[...defaultDocs, ...dependentesDocsList[index]].map((doc) => {
                                    const isDefaultDoc = DEFAULT_DOCS_IDS.includes(doc.id);

                                    const files = dependente.documents.filter((document) => document.id === doc.id);

                                    if (isDefaultDoc && !listRequiredIds.includes(doc.id)) return <></>;

                                    return (
                                        <CardDocument
                                            id={doc.id}
                                            name={doc.label}
                                            indexDependente={index}
                                            label={isDefaultDoc && 'Baixar (PDF)'}
                                            onLabelClick={() =>
                                                handleGeneratePDF({ id: doc.id, label: doc.label, data: dependente })
                                            }
                                            files={files}
                                            onFileChange={(event) =>
                                                handleFileChange({
                                                    event,
                                                    id: doc.id,
                                                    label: doc.label,
                                                    indexDependente: index,
                                                })
                                            }
                                            onDeleteFile={handleFileDelete}
                                            onClickViewFile={(dataFileClicked) =>
                                                handleShowModal({
                                                    hasFiles: !!files,
                                                    cpf: dependente.cpf.unmaskedValue,
                                                    ...dataFileClicked,
                                                })
                                            }
                                        />
                                    );
                                })}
                            </Accordion>
                        )
                )}
            <S.SpacingAccordion />
            {(titularDocsList.length > 0 || dependentesDocsList.some((docList) => docList.length > 0)) && (
                <Accordion title="Documentos complementares" hasCollapse={false}>
                    <CardDocument
                        id={-99}
                        name="Outros documentos"
                        files={othersDocuments || []}
                        isOthers
                        onFileChange={(event) =>
                            handleFileChange({ event, id: -99, label: 'Outros documentos', isOthers: true })
                        }
                        onDeleteFile={handleFileDelete}
                        onClickViewFile={(dataFileClicked) =>
                            handleShowModal({
                                hasFiles: !!othersDocuments,
                                cpf: dataTitular.cpf.unmaskedValue,
                                ...dataFileClicked,
                            })
                        }
                    />
                </Accordion>
            )}

            <ButtonSection>
                <Button id="backStep" type="secondary" onClick={handleSaveDraft}>
                    Salvar rascunho
                </Button>

                <ContainerButton>
                    <Button
                        id="backStep"
                        type="secondary"
                        onClick={() => {
                            const path = hasDependentes
                                ? '/movimentacao_cadastral/adicionar_dependente'
                                : '/movimentacao_cadastral/adicionar_titular';
                            history.push(path);
                        }}
                    >
                        Editar formulário
                    </Button>

                    <S.ButtonContinueCustom
                        id="continueStep"
                        type="primary"
                        onClick={handleFowardStep}
                        disabled={!titularDocsValidated || !dependentesDocsValidated}
                    >
                        Continuar
                    </S.ButtonContinueCustom>
                </ContainerButton>
            </ButtonSection>

            <Modal
                title={modalInfo.title}
                subtitle={modalInfo.content}
                modalSize="lg"
                visible={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                {modalInfo.backButton && (
                    <Button type="primary" onClick={() => setShowModal(false)}>
                        Voltar
                    </Button>
                )}
            </Modal>
        </PageContainer>
    );
}

export default Documentos;
